import styled from "styled-components"

export default styled.div`
  background: #000;
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 1080px;
  padding-bottom: 100px;
`



// WEBPACK FOOTER //
// ./src/Kiosk/KioskContent.js